import { akitaDevtools, persistState, resetStores } from "@datorama/akita";
import { Toast } from "primereact/toast";
import React, { createContext, useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import SimpleCrypto from "simple-crypto-js";
import { CoreConstants } from "../models/constants/core.constants";

let operationsAllowed: any = {};
const CoreServiceContext = createContext(operationsAllowed);

export const CoreServiceProvider = (props: any) => {
  let persistStorage: any;
  let simpleCrypto: SimpleCrypto;
  const { i18n } = useTranslation();
  const myToast: any = useRef(null);

  const setupApplication = () => {
    setupCryptography();
    setupStateManagement();
    // setLanguage();
  };

  const tearDownApplication = () => {
    resetStateManagement();
  };

  const setupCryptography = () => {
    simpleCrypto = new SimpleCrypto(CoreConstants.APP_SECRET_KEY);
  };

  const setupStateManagement = () => {
    if (process.env.NODE_ENV !== "production") {
      akitaDevtools();
    }

    persistStorage = persistState({
      include: ["session", "global", "users", "userCategories", "timeAndAttendance"],
      preStorageUpdate(storeName, state) {
        // This function is called before storing data into local storgage.
        if (simpleCrypto) {
          return simpleCrypto.encrypt(state);
        }
        return state;
      },
      preStoreUpdate(storeName, state) {
        // This function is called before storing data in in-memory storage.
        // E.g, what you see in Redux tab in browser.
        if (simpleCrypto) {
          return simpleCrypto.decrypt(state);
        }
        return state;
      },
    });
  };

  const resetStateManagement = () => {
    resetStores();

    if (persistStorage) {
      // It is important to execute this transaction as async operation because we need to wait for 'resetStores' to complete the process.
      setTimeout(() => {
        persistStorage.clearStore();
      }, 0);
    }
  };

  const updateLanguage = (language: string) => {
    i18n.changeLanguage(language);
  };

  const getLanguage = () => {
    return i18n.language;
  };

  const showToast = () => {
    myToast.current.show({
      severity: "error",
      summary: "some error",
      detail: "message detail",
    });
  };

  const getFullName = (firstName: string, lastName: string) => {
    if (firstName && lastName) {
      return firstName + " " + lastName;
    }
  };

  const getInitialsOfFullName = (firstName: string, lastName: string) => {
    if (firstName && lastName) {
      return firstName[0] + lastName[0];
    }
  };

  operationsAllowed = {
    setupApplication,
    tearDownApplication,
    updateLanguage,
    getLanguage,
    showToast,
    getFullName,
    getInitialsOfFullName
  };

  return (
    <CoreServiceContext.Provider value={operationsAllowed}>
      <Toast ref={myToast} />
      {props.children}
    </CoreServiceContext.Provider>
  );
};

export const useCoreService = () => {
  return useContext(CoreServiceContext);
};
